<template>
  <div id="Warning" v-if="judge('NotificationManagement_View')">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <!--                <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">-->
        <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
        <!--                    <el-breadcrumb-item>告警管理</el-breadcrumb-item>-->
        <!--                </el-breadcrumb>-->
        <nav-bar></nav-bar>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="$t('Equipment')" name="first">
            <el-form
              ref="formselect"
              :model="formselect"
              label-width="85px"
              class="queryform_div"
            >
              <areaSelect
                :level="level"
                :formArea="formArea"
                @areaList="getAreaList"
              >
              </areaSelect>
              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                  <el-form-item :label="$t('AlarmType')">
                    <el-select
                      :placeholder="$t('el.select.placeholder')"
                      v-model="recordsType"
                      filterable
                      class="queryform"
                    >
                      <el-option value="ASA" label="ASA"></el-option>
                      <el-option value="DataLoss" label="DataLoss"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                  <el-form-item :label="$t('Status')">
                    <el-select
                      :placeholder="$t('el.select.placeholder')"
                      v-model="dealType"
                      filterable
                      class="queryform"
                    >
                      <el-option
                        v-for="item in dealTypeOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                  <el-form-item :label="$t('EquipmentName')">
                    <el-select
                      :placeholder="$t('el.select.placeholder')"
                      v-model="deviceType"
                      filterable
                      class="queryform"
                    >
                      <el-option
                        v-for="item in deviceTypeOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                  <el-form-item :label="$t('TicketNumber')">
                    <el-input
                      class="queryform"
                      v-model="levelGroupId"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item :label="$t('CreateDate')">
                    <el-date-picker
                      type="daterange"
                      v-model="SystemAlarmTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :range-separator="$t('To')"
                      :start-placeholder="$t('StartDate')"
                      :end-placeholder="$t('EndDate')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item :label="$t('SolvedDate')">
                    <el-date-picker
                      type="daterange"
                      v-model="processTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :range-separator="$t('To')"
                      :start-placeholder="$t('StartDate')"
                      :end-placeholder="$t('EndDate')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item style="display: block">
                    <el-button @click="querydata" type="primary"
                    >{{ $t('Query') }}
                    </el-button
                    >
                    <el-button @click="exportdata" type="primary"
                    >{{ $t('Export') }}
                    </el-button
                    >

                    <el-button @click="reset">{{ $t('Reset') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <template>
              <el-table
                ref="multipleTable"
                :data="tableData1"
                v-loading="loading"
                border
                stripe
                style="width: 100%"
              >
                <el-table-column
                  fixed="left"
                  type="index"
                  :label="$t('SN')"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  fixed="left"
                  prop="levelGroupId"
                  :label="$t('TicketNumber')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="notificationType"
                  :label="$t('AlarmType')"
                  width="100"
                >
                </el-table-column>
                <el-table-column prop="deviceName" :label="$t('EquipmentName')" width="150">
                </el-table-column>
                <el-table-column prop="deviceCode" :label="$t('EquipmentCode')" width="150">
                </el-table-column>
                <el-table-column prop="deviceType" :label="$t('EquipmentType')" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.deviceType == 'WaterMeter'"
                    >水表</label
                    >
                    <label v-if="scope.row.deviceType == 'TemHumSensor'"
                    >{{ $t('TH-CALC') }}</label
                    >
                    <label v-if="scope.row.deviceType == 'SteamMeter'"
                    >{{ $t('SteamTable') }}</label
                    >
                    <label v-if="scope.row.deviceType == 'NaturalGasMeter'"
                    >{{ $t('NaturalGasMeter') }}</label
                    >
                    <label v-if="scope.row.deviceType == 'ElectricMeter'"
                    >{{ $t('Meter') }}</label
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="laboratoryName"
                  :label="$t('Lab')"
                  width="150"
                >
                </el-table-column>
                <el-table-column prop="buildingName" :label="$t('Building')" width="100">
                </el-table-column>
                <el-table-column prop="factoryName" :label="$t('Campus')" width="100">
                </el-table-column>
                <el-table-column prop="cityName" :label="$t('City')" width="100">
                </el-table-column>

                <el-table-column
                  prop="notificationLevel"
                  :label="$t('Severity')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.levelGroup == '2'">{{ $t('Level2') }}</label>
                    <label v-if="scope.row.levelGroup == '1'">{{ $t('Level1') }}</label>
                  </template>
                </el-table-column>
                <!--                       <el-table-column prop="notificationParam"-->
                <!--                                        label="告警参数"-->
                <!--                                        width="100">-->
                <!--                       </el-table-column>-->

                <!--                       <el-table-column prop="notifValue"-->
                <!--                                        label="告警次数"-->
                <!--                                        width="100">-->
                <!--                       </el-table-column>-->

                <!-- <el-table-column prop="notifThValue"
                                                label="告警阈值"
                                                width="100">
                                </el-table-column> -->
                <el-table-column
                  prop="notifDate"
                  :label="$t('AlarmOccuringDate')"
                  width="100"
                >
                </el-table-column>
                <el-table-column prop="status" :label="$t('Fixed')" width="100">
                  <template slot-scope="scope">
                    <label v-if="scope.row.status == '0'">{{ $t('No') }}</label>
                    <label v-else>{{ $t('yes') }}</label>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('SolutionInput')" width="200">
                </el-table-column>
                <el-table-column prop="dealAccount" :label="$t('ActionOwner')" width="100">
                </el-table-column>
                <el-table-column
                  prop="dealTime"
                  :label="$t('SolvedDate')"
                  width="100"
                >
                  <!-- <template slot-scope="scope">
                                                    <label v-if="scope.row.dealTime=='WaterMeter'">水表</label>
                                                </template> -->
                </el-table-column>
                <el-table-column fixed="right" :label="$t('Action')" width="90">
                  <template slot-scope="scope">
                    <el-button
                      @click="updateData(scope.row)"
                      type="primary"
                      size="small"
                      v-if="
                        scope.row.status === 0 &&
                        judge('NotificationManagement_Update')
                      "
                    >{{$t('Edit')}}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="5"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
              >
              </el-pagination>
            </template>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('System')"
            name="second"
            v-if="
              roleList.indexOf('SiteAdmin') != -1 ||
              roleList.indexOf('Admin') != -1
            "
          >
            <el-form
              ref="formselect"
              :model="formselect"
              label-width="80px"
              class="queryform_div"
            >
              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6" :lg="6">
                  <el-form-item :label="$t('TicketNumber')">
                    <el-input
                      class="queryform"
                      v-model="levelGroupId"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="6" :md="6" :lg="8">
                  <el-form-item :label="$t('TimeSlot')">
                    <el-date-picker
                      type="daterange"
                      v-model="selectTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :range-separator="$t('To')"
                      :start-placeholder="$t('StartDate')"
                      :end-placeholder="$t('EndDate')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="6" :md="6" :lg="6">
                  <el-form-item :label="$t('Status')">
                    <el-select
                      :placeholder="$t('el.select.placeholder')"
                      v-model="dealType"
                      filterable
                      class="queryform"
                    >
                      <el-option
                        v-for="item in dealTypeOpt"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-form-item>
                  <el-button @click="querydata" type="primary">{{ $t('Query') }}</el-button>
                  <el-button @click="reset">{{ $t('Reset') }}</el-button>
                </el-form-item>
              </el-row>
            </el-form>
            <template>
              <el-table
                ref="multipleTable"
                :data="tableData1"
                v-loading="loading"
                border
                stripe
                style="width: 100%"
              >
                <el-table-column
                  fixed="left"
                  type="index"
                  :label="$t('SN')"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  fixed="left"
                  prop="levelGroupId"
                  :label="$t('TicketNumber')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="notificationType"
                  :label="$t('AlarmType')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="notificationDescription"
                  :label="$t('AlarmDescription')"
                  width="150"
                >
                </el-table-column>
                <!-- <el-table-column prop="deviceType"
                                                label="告警设备"
                                                width="150">
                                    <template slot-scope="scope">
                                        <label v-if="scope.row.deviceType=='WaterMeter'">水表</label>
                                        <label v-if="scope.row.deviceType=='TemHumSensor'">温湿度计</label>
                                        <label v-if="scope.row.deviceType=='SteamMeter'">蒸汽表</label>
                                        <label v-if="scope.row.deviceType=='NaturalGasMeter'">天然气表</label>
                                        <label v-if="scope.row.deviceType=='ElectricMeter'">电表</label>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="laboratoryName"
                                                label="实验室"
                                                width="150">
                                </el-table-column>
                                <el-table-column prop="buildingName"
                                                label="楼宇"
                                                width="100">
                                </el-table-column>
                                <el-table-column prop="factoryName"
                                                label="园区"
                                                width="100">
                                </el-table-column>
                                <el-table-column prop="cityName"
                                                label="城市"
                                                width="100">
                                </el-table-column> -->

                <el-table-column
                  prop="notificationLevel"
                  :label="$t('Severity')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <label v-if="scope.row.levelGroup == '2'">{{ $t('Level2') }}</label>
                    <label v-if="scope.row.levelGroup == '1'">{{ $t('Level1') }}</label>
                  </template>
                </el-table-column>
                <!--                       <el-table-column prop="notificationParam"-->
                <!--                                        label="告警参数"-->
                <!--                                        width="100">-->
                <!--                       </el-table-column>-->

                <!--                       <el-table-column prop="notifValue"-->
                <!--                                        label="告警次数"-->
                <!--                                        width="100">-->
                <!--                       </el-table-column>-->

                <!-- <el-table-column prop="notifThValue"
                                                label="告警阈值"
                                                width="100">
                                </el-table-column> -->
                <el-table-column
                  prop="notifDate"
                  :label="$t('AlarmOccuringDate')"
                  width="100"
                >
                </el-table-column>
                <el-table-column prop="status" :label="$t('Fixed')" width="100">
                  <template slot-scope="scope">
                    <label v-if="scope.row.status == '0'">{{ $t('No') }}</label>
                    <label v-else>{{ $t('yes') }}</label>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('SolutionInput')" width="200">
                </el-table-column>
                <el-table-column prop="dealAccount" :label="$t('ActionOwner')" width="100">
                </el-table-column>
                <el-table-column
                  prop="dealTime"
                  :label="$t('SolvedDate')"
                  width="100"
                >
                  <!-- <template slot-scope="scope">
                                                    <label v-if="scope.row.dealTime=='WaterMeter'">水表</label>
                                                </template> -->
                </el-table-column>
                <el-table-column :label="$t('Action')" width="90">
                  <template slot-scope="scope">
                    <el-button
                      @click="updateData(scope.row)"
                      type="primary"
                      size="small"
                      v-if="
                        scope.row.status === 0 &&
                        judge('NotificationManagement_Update')
                      "
                    >{{$t('Edit')}}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="5"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="total"
                :current-page="currentPage"
              >
              </el-pagination>
            </template>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-scrollbar>
    <el-dialog
      :title="$t('AlarmHandling')"
      :visible.sync="dialogAlarm"
      width="80%"
      top="10vh"
    >
      <el-form ref="Alarmform" :model="Alarmform" label-width="100px">
        <el-row :gutter="24">
          <!-- <el-col :span="8">
                        <el-form-item label="告警编号">
                            <el-input v-model="Alarmform.id" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col> -->
          <el-col :span="8">
            <el-form-item :label="$t('AlarmType')">
              <el-input
                v-model="Alarmform.notificationType"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('EquipmentName')">
              <el-input
                v-model="Alarmform.deviceName"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('City')">
              <el-input
                v-model="Alarmform.cityName"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Campus')">
              <el-input
                v-model="Alarmform.factoryName"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Building')">
              <el-input
                v-model="Alarmform.buildingName"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Lab')">
              <el-input
                v-model="Alarmform.laboratoryName"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('Severity')">
              <el-input
                v-model="Alarmform.notifLevle"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--                    <el-col :span="8">-->
          <!--                        <el-form-item label="告警参数">-->
          <!--                            <el-input v-model="Alarmform.notifParam" :disabled="true"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :span="8">
            <el-form-item :label="$t('AlarmOccuringDate')">
              <el-input
                v-model="Alarmform.notifDate"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--                    <el-col :span="8">-->
          <!--                        <el-form-item label="正常值">-->
          <!--                            <el-input v-model="Alarmform.equipment" :disabled="true"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <!-- <el-col :span="8">
                        <el-form-item label="告警阈值">
                            <el-input v-model="Alarmform.notifThValue" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col> -->
          <el-col :span="24">
            <el-form-item :label="$t('Details')">
              <el-table :data="Alarmform.detailListV1">
                <el-table-column
                  prop="notificationType"
                  :label="$t('AlarmType')"
                ></el-table-column>
                <el-table-column
                  prop="notificationParam"
                  :label="$t('AlarmParameters')"
                ></el-table-column>
                <el-table-column
                  prop="notificationDescription"
                  :label="$t('AlarmDescription')"
                ></el-table-column>
                <el-table-column prop="notificaType" :label="$t('EquipmentType')">
                  <template slot-scope="scope">
                    <label v-if="scope.row.notificaType == 'Ammeter'"
                    >{{ $t('Meter') }}</label
                    >
                    <label v-else-if="scope.row.notificaType == 'Sensor'"
                    >传感器</label
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="deviceBrand" :label="$t('EquipmentBrand')">
                  <!--                                <template slot-scope="scope">-->
                  <!--                                    <label v-if="scope.row.deviceType=='WaterMeter'">水表</label>-->
                  <!--                                    <label v-if="scope.row.deviceType=='TemHumSensor'">温湿度计</label>-->
                  <!--                                    <label v-if="scope.row.deviceType=='SteamMeter'">蒸汽表</label>-->
                  <!--                                    <label v-if="scope.row.deviceType=='NaturalGasMeter'">天然气表</label>-->
                  <!--                                    <label v-if="scope.row.deviceType=='ElectricMeter'">电表</label>-->
                  <!--                                </template>-->
                </el-table-column>
                <el-table-column
                  prop="deviceCode"
                  :label="$t('DeviceCode')"
                ></el-table-column>
                <el-table-column
                  prop="notificaProperty"
                  :label="$t('AlarmProperty')"
                ></el-table-column>
                <el-table-column
                  prop="notifValue"
                  :label="$t('AlarmValue')"
                ></el-table-column>
                <el-table-column prop="notificaLevel" :label="$t('Severity')">
                  <template slot-scope="scope">
                    <label
                      v-if="
                        scope.row.notificationType == 'ASA' &&
                        scope.row.alarmBoundary == 'up'
                      "
                      style="color: red"
                    >{{ scope.row.notificaLevel }}</label
                    >
                    <label
                      v-else-if="
                        scope.row.notificationType == 'ASA' &&
                        scope.row.alarmBoundary == 'down'
                      "
                      style="color: blue"
                    >{{ scope.row.notificaLevel }}</label
                    >
                    <label
                      v-else-if="scope.row.notificationType == 'DataLoss'"
                    >{{ scope.row.notificaLevel }}</label
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="notifThValue"
                  :label="$t('AlarmThreshold')"
                ></el-table-column>
                <el-table-column
                  prop="notificaStartTime"
                  :label="$t('AlarmStartTime')"
                ></el-table-column>
                <el-table-column
                  prop="notificaEndTime"
                  :label="$t('AlarmEndTime')"
                ></el-table-column>
                <el-table-column
                  prop="notificaTimes"
                  :label="$t('AlarmNumbers')"
                ></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <!--                    <hr style="border: 1px solid #dadada;margin: 20px;border-top: 0;" />-->
          <el-col :span="24">
            <el-form-item :label="$t('SolutionInput')">
              <el-input
                v-model="Alarmform.remark"
                :rows="3"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="text-align: center">
            <el-button type="success" @click="onSubmit">{{$t('Confirm')}}</el-button>
            <el-button @click="dialogAlarm = false">{{ $t('Cancel') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import areaSelect from "../../components/content/maintabber/areaSelect";
import {
  GetAllNotificationRecords,
  UpdateNotificationRecords,
  ExportNotificationData,
  exportExcelAlarmList,
  dateFormat,
} from "../../api/api";
import {mapState} from "vuex";
import {
  fancha,
  getLocalTime,
  judgePermission,
  getISOtime,
} from "../../utils/util";
import datefilter from "../../utils/filter";
import {getItemFormLocalstorage} from "../../../utils/package-localstorage";

export default {
  name: "Warning",
  components: {
    areaSelect,
  },
  data() {
    return {
      total: 0,
      formArea: {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      },
      area: JSON.parse(sessionStorage.getItem("area")),
      dialogAlarm: false,
      loading: false,
      formselect: {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      },
      tableData1: [],
      level: 4,
      Alarmform: {},
      queryString: "",
      recordsType: "",
      dealType: "",
      SystemAlarmTime: "",
      processTime: "",

      deviceType: "",
      levelGroupId: "",
      // deviceTypeOpt: [
      //   {value: "", label: "全部"},
      //   {value: "TemHumSensor", label: "温湿度计"},
      //   {value: "ElectricMeter", label: this.$t('Meter')},
      // ],
      selectTime: "",
      startTime: "",
      endTime: "",
      pageSize: 5,
      current: 0,
      currentPage: 1,
      activeName: "first",
      roleList: "",
      isShow: false,
    };
  },
  created() {
    this.roleList = getItemFormLocalstorage("roles");
    this.dealType = this.dealTypeOpt[0].value;
  },

  mounted() {
    if (this.$route.params.value) {
      var data = fancha(this.$route.params.value);
      this.formArea = {
        cityId: this.area[data[0]].value,
        factoryId: this.area[data[0]].children[data[1]].value,
        buildingId: "",
        LabId: "",
        deviceId: "",
      };
      this.formselect.cityId = this.area[data[0]].value;
      this.formselect.factoryId = this.area[data[0]].children[data[1]].value;
    }
    this.getData();
  },
  methods: {
    judge(e) {
      return judgePermission(e);
    },

    handleClick() {
      this.current = 0;
      this.currentPage = 1;
      this.tableData1 = [];
      this.dealType = this.dealTypeOpt[0].value;
      this.endTime = "";
      this.startTime = "";
      this.selectTime = "";
      this.getData();
    },
    reset() {
      this.formselect = {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      };
      this.formArea = {
        cityId: "",
        factoryId: "",
        buildingId: "",
        LabId: "",
        deviceId: "",
      };
      this.dealType = this.dealTypeOpt[0].value;
      this.startTime = "";
      this.endTime = "";
      this.selectTime = "";
      this.getData();
    },
    handleCurrentChange(val) {
      this.current = (val - 1) * this.pageSize;
      this.currentPage = val;

      this.getData();
    },
    getAreaList(e) {

      this.formselect = e.Valueform;
    },
    querydata() {
      if (
        this.formselect.cityId != "" ||
        this.formselect.factoryId != "" ||
        this.formselect.LabId != "" ||
        this.formselect.buildingId != ""
      ) {
        this.current = 0;
        this.currentPage = 1;
      }
      this.getData();
    },

    exportdata() {
      this.loading = true;
      var data = this.formselect,
        that = this;
      if (this.activeName == "first") {
        data.queryString = "deviceAlarm";
      }
      if (this.activeName == "second") {
        data.queryString = "systemAlarm";
      }

      data.recordsType = this.recordsType;
      data.dealType = this.dealType;
      if (this.selectTime) {
        this.startTime = getISOtime(this.selectTime[0]);
        this.endTime = getISOtime(this.selectTime[1]);
      }
      data.startTime = this.startTime;
      data.endTime = this.endTime;

      data.SystemAlarmTimestartTime = "";
      data.SystemAlarmTimeendTime = "";
      if (this.SystemAlarmTime) {
        data.SystemAlarmTimestartTime = getISOtime(this.SystemAlarmTime[0]);
        data.SystemAlarmTimeendTime = getISOtime(this.SystemAlarmTime[1]);
      }
      data.processTimestartTime = "";
      data.processTimeendTime = "";
      if (this.processTime) {
        data.processTimestartTime = getISOtime(this.processTime[0]);
        data.processTimeendTime = getISOtime(this.processTime[1]);
      }
      data.deviceType = this.deviceType;

      var excelData1 = [
        [
          "告警ID",
          this.$t('AlarmType'),
          this.$t('AlarmParameters'),
          this.$t('AlarmProperty'),
          this.$t('EquipmentName'),
          this.$t('DeviceCode'),
          this.$t('EquipmentBrand'),
          this.$t('AlarmDescription'),
          this.$t('City'),
          this.$t('Campus'),
          this.$t('Building'),
          this.$t('Lab'),
          this.$t('Severity'), //（取第一层页面中的等级）
          this.$t('AlarmValue'),
          this.$t('AlarmThreshold'),
          "告警详细等级", //（取明细表中等级）
          this.$t('Fixed'),
          this.$t('AlarmOccuringDate'), //（取第一层页面中的等级）
          this.$t('AlarmStartTime'), //（取明细中数据）
          this.$t('AlarmEndTime'), //（取明细中数据）
          this.$t('AlarmNumbers'), //（取明细中数据）
          this.$t('SolutionInput'),
          this.$t('ActionOwner'),
          this.$t('CloseDate'),
        ],
      ];
      var fileName =
        "告警导出" + that.formatDate(new Date(), "yyyyMMddhhmmss") + ".xlsx";
      ExportNotificationData(data, "id ASC", this.pageSize, this.current).then(
        (res) => {
   
          if (res.result) {
            res.result.forEach((item) => {
              let rowData = [];
              rowData = [
                item.levelGroupId,
                item.notificationType,
                item.notificationParam,
                this.checkData(item).notificaProperty,
                item.deviceName,
                item.deviceCode,
                this.checkData(item).deviceBrand,

                item.notificationDescription,
                item.cityName,
                item.factoryName,
                item.buildingName,
                item.laboratoryName,
                item.notificationLevel,
                this.checkData(item).notifValue,
                this.checkData(item).notifThValue,
                this.checkData(item).notificaLevel,

                item.status == 1 ? this.$t('yes') : this.$t('No'),
                item.notifDate,
                this.checkData(item).notificaStartTime,
                this.checkData(item).notificaEndTime,
                this.checkData(item).notificaTimes,

                item.remark,

                item.dealAccount,
                dateFormat(item.dealTime, "yyyy-MM-dd HH:mm:ss", 8),
              ];
              excelData1.push(rowData);
            });
            exportExcelAlarmList(excelData1, fileName);
            this.loading = false;
          }
        }
      );
    },

    checkData(e) {
   
      var data = e.notificationContent.split(";");
      let res = {};
      if (e.notificationType == "ASA") {
        res.notificaType = data[0];
        res.deviceBrand = data[1];
        //res.deviceCode = data[2];
        res.notificaProperty = data[3];
        res.notificaLevel = data[4];
        res.notificaStartTime = data[5];
        res.notificaEndTime = data[6];
        res.notificaTimes = data[7];
        res.notifValue = data[11];
        res.notifThValue = data[13];
      }
      if (e.notificationContent == "DataLoss") {
        res.deviceCode = data[0];
        if (e.notificationLevel == "2") {
          res.notificaLevel = "Level2";
        }
        if (e.notificationLevel == "1") {
          res.notificaLevel = "Level1";
        }
      }
      return res;
    },

    formatDate(date, fmt) {
      var that = this;
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : that.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    //获取数据
    getData() {
      this.loading = true;
      var data = this.formselect,
        that = this;
      if (this.activeName == "first") {
        data.queryString = "deviceAlarm";
      }
      if (this.activeName == "second") {
        data.queryString = "systemAlarm";
      }

      data.recordsType = this.recordsType;
      data.dealType = this.dealType;
      if (this.selectTime) {
        this.startTime = getISOtime(this.selectTime[0]);
        this.endTime = getISOtime(this.selectTime[1]);
      }
      data.SystemAlarmTimestartTime = "";
      data.SystemAlarmTimeendTime = "";
      if (this.SystemAlarmTime) {
        data.SystemAlarmTimestartTime = getISOtime(this.SystemAlarmTime[0]);
        data.SystemAlarmTimeendTime = getISOtime(this.SystemAlarmTime[1]);
      }
      data.processTimestartTime = "";
      data.processTimeendTime = "";
      if (this.processTime) {
        data.processTimestartTime = getISOtime(this.processTime[0]);
        data.processTimeendTime = getISOtime(this.processTime[1]);
      }
      data.startTime = this.startTime;
      data.endTime = this.endTime;
      data.deviceType = this.deviceType;
      data.levelGroupId = this.levelGroupId;
      if (data.cityId || data.factoryId || data.LabId || data)
        GetAllNotificationRecords(
          data,
          "id ASC",
          this.pageSize,
          this.current
        ).then((res) => {
          // console.log(res)
          if (res.success) {
            that.loading = false;
            that.tableData1 = res.result.items;
            that.total = res.result.totalCount;
            that.tableData1.map((item) => {
              item.dealTime = item.dealTime ? getLocalTime(item.dealTime) : "";
              // var data1 = fancha(item.notificationObject)
              // item.city = this.area[data1[0]].label
              // item.park = this.area[data1[0]].children[data1[1]].label
              // item.building = this.area[data1[0]].children[data1[1]].children[data1[2]].label
              // item.lab = this.area[data1[0]].children[data1[1]].children[data1[2]].children[data1[3]].label
              // console.log(data)
            });
          }
          // console.log(that.tableData1)
        });
    },
    updateData(e) {
      this.dialogAlarm = true;
      this.Alarmform = e;
      this.Alarmform.detailListV1.map((item) => {
       
        if (item.notificationType == "ASA") {
          var data = item.notificationContent.split(";");
          item.notificaType = data[0];
          item.deviceBrand = data[1];
          item.deviceCode = data[2];
          item.notificaProperty = data[3];
          item.notificaLevel = data[4];
          item.notificaStartTime = data[5];
          item.notificaEndTime = data[6];
          item.notificaTimes = data[7];
          item.notifValue = data[11];
          item.notifThValue = data[13];
        }
        if (item.notificationType == "DataLoss") {
          var data = item.notificationContent.split(";");
          item.deviceCode = data[0];
          if (item.notificationLevel == "2") {
            item.notificaLevel = "Level2";
          }
          if (item.notificationLevel == "1") {
            item.notificaLevel = "Level1";
          }
        }
      });
      console.log(this.Alarmform);
    },
    onSubmit() {
      var data = this.Alarmform;
      if (!data.remark) {
        this.$message.warning(this.$t('ProcessingContent'));
        return;
      }
      UpdateNotificationRecords(data).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('SuccessfullyProcessed'));
          this.dialogAlarm = false;
          this.getData();
        }
      });
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,

    dealTypeOpt: function () {
      return [
        {
          value: "0",
          label: this.$t('Untreated'),
        },
        {
          value: "1",
          label: this.$t('Processed'),
        },
      ]
    },
    deviceTypeOpt: function () {
      return [
        {value: "", label: this.$t('All')},
        {value: "TemHumSensor", label: this.$t('TH-CALC')},
        {value: "ElectricMeter", label: this.$t('Meter')},
      ]
    }
  }),

};
</script>

<style scoped>
</style>
